import React from 'react';
import { useRef } from 'react';
import './Btn.css'
import VariableProximity from './VariableProx';
import { Link } from 'react-router-dom';

const Btn = (props) => {
  const containerRef = useRef(null);

    return ( 
      <Link to={props.BtnPath}>
        <button className={props.className} type={props.BtnType} onChange={props.BtnOnChange}>  
         <div
            ref={containerRef}
            style={{position: 'relative'}}
            >
              <VariableProximity
                label={props.BtnText}
                className={'variable-proximity-demo'}
                fromFontVariationSettings="'wght' 400, 'opsz' 9"
                toFontVariationSettings="'wght' 1000, 'opsz' 40"
                containerRef={containerRef}
                radius={100}
                falloff="linear"
              />
          </div>                      
        </button>
      </Link>
        
     );
}
 
export default Btn;